import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import './CreatorApplication.scss';

import { updateCreatorApplication } from '../../Actions/ApplicationActions';
import { removeUrlParam, getUrlParam } from '../../Helpers/helpers';
import { getCreatorAppliationWaitlistObject } from '../../Helpers/waitlist_helpers';

import CreatorApplicationData from '../../Components/Application/CreatorApplicationData';
import CreatorApplicationPersonalInfo from '../../Components/Application/CreatorApplicationPersonalInfo';
import CreatorApplicationSocialInfo from '../../Components/Application/CreatorApplicationSocialInfo';
import CreatorApplicationLinkSocials from '../../Components/Application/CreatorApplicationLinkSocials';

const CreatorApplication = props => {
  const { application } = props;
  const history = useHistory();
  const referringUserUsername = getUrlParam('referral');
  const creatorAppliationWaitlistObject = getCreatorAppliationWaitlistObject(application);

  const [referringUser, setReferringUser] = useState(null);
  const [referringBrand, setReferringBrand] = useState(null);
  const [activeTabName, setActiveTabName] = useState(creatorAppliationWaitlistObject.id ? 'Link Socials' : 'Personal Info');
  const removeReferral = () => {
    setReferringUser(null);
    setReferringBrand(null);
    removeUrlParam('referral');
    removeUrlParam('referring_brand');
    props.updateCreatorApplication({ referringUser: null, referringBrand: null, ReferringUser_id: null, referringBrand_id: null });
  };

  const goToNextTab = () => {
    const currentIndex = tabs.findIndex(tab => tab.name === activeTabName);
    const nextIndex = (currentIndex + 1) % tabs.length;
    setActiveTabName(tabs[nextIndex].name);
  };

  const goToPreviousTab = () => {
    const currentIndex = tabs.findIndex(tab => tab.name === activeTabName);
    if (currentIndex === -1) return;
    else if (currentIndex === 0 && (referringUser || referringBrand)) history.push(`/join/${referringUserUsername}`);
    else if (currentIndex === 0) history.push('/home');

    const previousIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    setActiveTabName(tabs[previousIndex].name);
  };

  const tabs = [
    {
      name: 'Personal Info',
      Component: (
        <CreatorApplicationPersonalInfo
          goToPreviousTab={goToPreviousTab}
          goToNextTab={goToNextTab}
          referringUser={referringUser}
          referringBrand={referringBrand}
          removeReferral={removeReferral}
        />
      )
    },
    {
      name: 'Social Info',
      Component: <CreatorApplicationSocialInfo goToPreviousTab={goToPreviousTab} goToNextTab={goToNextTab} />
    },
    {
      name: 'Link Socials',
      Component: <CreatorApplicationLinkSocials />
    }
  ];
  const activeTab = tabs.find(tab => tab.name === activeTabName);

  return (
    <div className='creator-application-outer'>
      <CreatorApplicationData application={application} setReferringUser={setReferringUser} setReferringBrand={setReferringBrand} />
      <div className='creator-application-inner'>{!!activeTab && activeTab.Component}</div>
    </div>
  );
};

CreatorApplication.propTypes = {
  application: PropTypes.object.isRequired,
  ui: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  application: state.application,
  ui: state.ui
});

export default connect(mapStateToProps, {
  updateCreatorApplication
})(CreatorApplication);
